import { render } from "./MUTT-Backend.vue?vue&type=template&id=0de5015f&scoped=true"
import script from "./MUTT-Backend.vue?vue&type=script&lang=js"
export * from "./MUTT-Backend.vue?vue&type=script&lang=js"

import "./MUTT-Backend.vue?vue&type=style&index=0&id=0de5015f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de5015f"]])

export default __exports__